<template>
	<main>
		<Login></Login>
		<div class="container pt-5 pb-5" v-if="!isModalVisible">
			<section data-aos="fade-up">
				<div class="col-md-12">
					<h4 class="pb-5">New Products</h4>
				</div>
			</section>
			<section class="content_padding pb-3" style="display: flex;">
				<div class="width_10 row">
					<ul class="navbar-nav ">
						<li class="nav-item col-md">
							<router-link class="nav-link text-muted" to="/">Originality</router-link>
						</li>
						<li class="nav-item col-md">
							<router-link class="nav-link text-muted" to="/">Pilot Production</router-link>
						</li>
						<li class="nav-item col-md">
							<router-link class="nav-link text-muted" to="/">Mass Production</router-link>
						</li>
					</ul>
				</div>
			</section>
			<section class="pt-3 pb-3">
				<SearchInput class="content_padding" v-model="inputValue" />
			</section>
			<section class="pt-4 pb-4" data-aos="fade-up">
				<div class="row">
					<div class="col-md-4 content_padding mb-4" @click="navigateTo()">
						<div class="card shadow-sm card-border">
							<img class="card-img-top" src="/assets/img/Products/product1.png" alt="Card image cap">
							<div class="card-body card-body-list">
								<h6 class="card-title mb-1" style="color: #FCB42E;">SA6053</h6>
								<p class="card-title card-sub-title mb-1">
									Work Light,position light（red/amber/white）
								</p>
								<p class="card-text text-muted multiline">
									Engineered with precision optics and advanced LED or HID technology, our
									lights
									provide superior brightness, optimal beam patterns. Whether you’re
									navigating
									urban
									streets or off-road adventures, our lights are engineered to perform and
									built
									to
									last.
								</p>
							</div>
						</div>
					</div>
					<div class="col-md-4 content_padding mb-4" @click="navigateTo()">
						<div class="card shadow-sm card-border">
							<img class="card-img-top" src="/assets/img/Products/product2.png" alt="Card image cap">
							<div class="card-body card-body-list">
								<h6 class="card-title mb-1" style="color: #FCB42E;">SA6053</h6>
								<p class="card-title card-sub-title mb-1">
									Work Light,position light（red/amber/white）
								</p>
								<p class="card-text text-muted multiline">
									Engineered with precision optics and advanced LED or HID technology, our
									lights
									provide superior brightness, optimal beam patterns. Whether you’re
									navigating
									urban
									streets or off-road adventures, our lights are engineered to perform and
									built
									to
									last.
								</p>
							</div>
						</div>
					</div>
					<div class="col-md-4 content_padding mb-4" @click="navigateTo()">
						<div class="card shadow-sm card-border">
							<img class="card-img-top" src="/assets/img/Products/product3.png" alt="Card image cap">
							<div class="card-body card-body-list">
								<h6 class="card-title mb-1" style="color: #FCB42E;">SA6053</h6>
								<p class="card-title card-sub-title mb-1">
									Work Light,position light（red/amber/white）
								</p>
								<p class="card-text text-muted multiline">
									Engineered with precision optics and advanced LED or HID technology, our
									lights
									provide superior brightness, optimal beam patterns. Whether you’re
									navigating
									urban
									streets or off-road adventures, our lights are engineered to perform and
									built
									to
									last.
								</p>
							</div>
						</div>
					</div>
					<div class="col-md-4 content_padding mb-4" @click="navigateTo()">
						<div class="card shadow-sm card-border">
							<img class="card-img-top" src="/assets/img/Products/product4.png" alt="Card image cap">
							<div class="card-body card-body-list">
								<h6 class="card-title mb-1" style="color: #FCB42E;">SA6053</h6>
								<p class="card-title card-sub-title mb-1">
									Work Light,position light（red/amber/white）
								</p>
								<p class="card-text text-muted multiline">
									Engineered with precision optics and advanced LED or HID technology, our
									lights
									provide superior brightness, optimal beam patterns. Whether you’re
									navigating
									urban
									streets or off-road adventures, our lights are engineered to perform and
									built
									to
									last.
								</p>
							</div>
						</div>
					</div>
					<div class="col-md-4 content_padding mb-4" @click="navigateTo()">
						<div class="card shadow-sm card-border">
							<img class="card-img-top" src="/assets/img/Products/product5.png" alt="Card image cap">
							<div class="card-body card-body-list">
								<h6 class="card-title mb-1" style="color: #FCB42E;">SA6053</h6>
								<p class="card-title card-sub-title mb-1">
									Work Light,position light（red/amber/white）
								</p>
								<p class="card-text text-muted multiline">
									Engineered with precision optics and advanced LED or HID technology, our
									lights
									provide superior brightness, optimal beam patterns. Whether you’re
									navigating
									urban
									streets or off-road adventures, our lights are engineered to perform and
									built
									to
									last.
								</p>
							</div>
						</div>
					</div>
					<div class="col-md-4 content_padding mb-4" @click="navigateTo()">
						<div class="card shadow-sm card-border">
							<img class="card-img-top" src="/assets/img/Products/product6.png" alt="Card image cap">
							<div class="card-body card-body-list">
								<h6 class="card-title mb-1" style="color: #FCB42E;">SA6053</h6>
								<p class="card-title card-sub-title mb-1">
									Work Light,position light（red/amber/white）
								</p>
								<p class="card-text text-muted multiline">
									Engineered with precision optics and advanced LED or HID technology, our
									lights
									provide superior brightness, optimal beam patterns. Whether you’re
									navigating
									urban
									streets or off-road adventures, our lights are engineered to perform and
									built
									to
									last.
								</p>
							</div>
						</div>
					</div>
					<div class="col-md-4 content_padding mb-4" @click="navigateTo()">
						<div class="card shadow-sm card-border">
							<img class="card-img-top" src="/assets/img/Products/product7.png" alt="Card image cap">
							<div class="card-body card-body-list">
								<h6 class="card-title mb-1" style="color: #FCB42E;">SA6053</h6>
								<p class="card-title card-sub-title mb-1">
									Work Light,position light（red/amber/white）
								</p>
								<p class="card-text text-muted multiline">
									Engineered with precision optics and advanced LED or HID technology, our
									lights
									provide superior brightness, optimal beam patterns. Whether you’re
									navigating
									urban
									streets or off-road adventures, our lights are engineered to perform and
									built
									to
									last.
								</p>
							</div>
						</div>
					</div>
					<div class="col-md-4 content_padding mb-4" @click="navigateTo()">
						<div class="card shadow-sm card-border">
							<img class="card-img-top" src="/assets/img/Products/product8.png" alt="Card image cap">
							<div class="card-body card-body-list">
								<h6 class="card-title mb-1" style="color: #FCB42E;">SA6053</h6>
								<p class="card-title card-sub-title mb-1">
									Work Light,position light（red/amber/white）
								</p>
								<p class="card-text text-muted multiline">
									Engineered with precision optics and advanced LED or HID technology, our
									lights
									provide superior brightness, optimal beam patterns. Whether you’re
									navigating
									urban
									streets or off-road adventures, our lights are engineered to perform and
									built
									to
									last.
								</p>
							</div>
						</div>
					</div>
					<div class="col-md-4 content_padding mb-4" @click="navigateTo()">
						<div class="card shadow-sm card-border">
							<img class="card-img-top" src="/assets/img/Products/product9.png" alt="Card image cap">
							<div class="card-body card-body-list">
								<h6 class="card-title mb-1" style="color: #FCB42E;">SA6053</h6>
								<p class="card-title card-sub-title mb-1">
									Work Light,position light（red/amber/white）
								</p>
								<p class="card-text text-muted multiline">
									Engineered with precision optics and advanced LED or HID technology, our
									lights
									provide superior brightness, optimal beam patterns. Whether you’re
									navigating
									urban
									streets or off-road adventures, our lights are engineered to perform and
									built
									to
									last.
								</p>
							</div>
						</div>
					</div>
				</div>
			</section>
		</div>
		<div class="pt-3 pb-5" style="display:none">
			<img src="/assets/img/VIP/noProduct.png" style="max-height:26rem;max-width:26rem">
			<p style="position: relative;top: -2rem;">Please <span style="color:#FCB42E">login</span> to view</p>
		</div>

	</main>
</template>

<script>
import SearchInput from '@/components/common/SearchInput.vue';
import Login from '@/views/Login.vue';
import { mapState } from 'vuex';

export default {
	data() {
		return {

		};
	},
	computed: {
		...mapState('modal', ['showModal']),

		isModalVisible() {
			return this.showModal;
		},
		isFloating() {
			return this.$store.state.modal.isFloating; // 判断是否为悬浮模式
		},

	},
	components: {
		SearchInput,
		Login
	},
	methods: {

		navigateTo() {
			this.$router.push(`/products/WarningLights/name`);
		}
	},

};
</script>

<style scoped>
@import '../../assets/css/main.css';

:deep(.width_10 .navbar-nav) {
	display: contents;
}

:deep(.nav-item::before) {
	content: "";
	position: absolute;
	top: 10%;
	bottom: 10%;
	left: 0;
	width: 0.5px;
	background-color: #454545;
}

:deep(.nav-item::after) {
	content: "";
	position: absolute;
	top: 10%;
	bottom: 10%;
	right: 0;
	width: 0.5px;
	background-color: #454545;
}

:deep(.navbar) {
	padding: 0 1rem;
}

:deep(.navbar-nav li) {
	display: flex;
	justify-content: center;
	height: 2rem;
	line-height: 2rem;
}

:deep(.navbar-nav li a) {
	display: block;
	width: 12rem;
}

:deep(.nav-item:hover a) {
	background-color: #FCB42E;
	border-radius: 0.2rem;
	color: #000 !important;
}

:deep(.card) {
	background-color: #000000;
}

:deep(.card-title) {
	font-weight: 600;
	margin-bottom: 0rem;
}

:deep(.card-sub-title) {
	color: #fff;
	height: 1.5rem;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

:deep(.card-border) {
	border: 1px solid #474746;
}

:deep(.card-img-top) {
	min-height: 14.5rem;
	/* object-fit: cover; */
	max-height: 14.5rem;
	background: linear-gradient(to bottom right, #2C2C2C, #000000);
}

:deep(.card-body-list) {
	text-align: left;
	height: 12.3rem;
	background-color: #000000;
	border-bottom-left-radius: calc(0.25rem - 1px);
	border-bottom-right-radius: calc(0.25rem - 1px);
}

:deep(.multiline) {
	color: #5F5F5F !important;
	overflow: hidden;
	font-size: 15px;
	display: -webkit-box;
	-webkit-line-clamp: 4;
	-webkit-box-orient: vertical;
	text-overflow: ellipsis;
}
</style>
